import {useEffect} from 'react';
import {useJwt} from 'react-jwt';
import {useSearchParams} from 'react-router-dom';
import {useGetMe} from 'api/generated';
import {usePersistentStore} from 'stores';
import {Spinner} from 'components';
import {useDelay} from 'hooks';

import AcceptInviteAccountNeeded from './AcceptInvite.AccountNeeded';
import AcceptInviteJoin from './AcceptInvite.Join';

interface IAcceptInviteProps {}

const AcceptInvite = ({}: IAcceptInviteProps) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const {decodedToken} = useJwt(token) as {decodedToken: {invitor: string | undefined}};
  const invitor = decodedToken?.invitor ?? '';

  const {data: meData, isPending} = useGetMe();
  const me = meData?.data?.data;

  const setUrlAfterAuth = usePersistentStore(s => s.setUrlAfterAuth);
  useEffect(() => {
    setUrlAfterAuth(me ? '' : location.pathname + location.search);
  }, [me]);

  const {isDelaying} = useDelay(500);
  if (isDelaying || isPending) {
    return (
      <div className="flex justify-center py-24">
        <Spinner />
      </div>
    );
  }

  if (!me) {
    return <AcceptInviteAccountNeeded invitor={invitor} />;
  }

  return <AcceptInviteJoin invitor={invitor} />;
};

export default AcceptInvite;
